module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workbench"
  }, [_c('div', {
    staticClass: "workbench__canvas",
    attrs: {
      "id": "canvas"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "workbench__loader"
  }, [_c('loader-dots')], 1) : _vm._e(), _vm._v(" "), _c('scroll-panel', {
    staticClass: "workbench__canvas-content"
  }, [_c('workbench-row', {
    ref: "viewership",
    staticClass: "workbench__canvas__las",
    style: ({
      height: _vm.viewershipRowHeight
    })
  }, [_c('audience-size', {
    staticClass: "workbench__audience workbench__canvas-block",
    attrs: {
      "validStreamingOptions": _vm.validStreamingOptions,
      "size": _vm.audienceSize,
      "onSelectedViewingStream": _vm.onSelectedViewingStream,
      "viewershipOption": _vm.viewership
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "workbench__canvas-block workbench__viewership"
  }, [_c('viewership', {
    attrs: {
      "networks": _vm.networks,
      "selectedNetworks": _vm.selectedViewershipNetworks,
      "selectedDayPartNetworks": _vm.selectedDayPartNetworks,
      "viewership-data": _vm.viewershipData
    }
  })], 1)], 1), _vm._v(" "), (_vm.selectedDayPartNetworks.length > 0) ? _c('workbench-row', [_c('day-parts', {
    attrs: {
      "selectedNetworks": _vm.selectedDayPartNetworks,
      "viewershipData": _vm.viewershipData,
      "networks": _vm.networks,
      "dayPartsConfig": _vm.dayPartsCofig
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('workbench-row', {
    ref: "universe",
    staticClass: "workbench__universe",
    style: ({
      height: _vm.universeRowHeight
    })
  }, [_c('universe-stability', {
    staticClass: "workbench__canvas-block",
    attrs: {
      "universe": _vm.universeData
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-672d7eec","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/lasGraphs/LasGraphs.vue
// module id = 2102
// module chunks = 0